import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LandingPage from '../pages/LandingPage';
import AppLayout from './layout/AppLayout';
import DashboardPage from '../pages/DashboardPage';

/**
 * Show landing page to logged-out users, Dashboard to logged-in users at "/".
 */
export default function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <LandingPage />;
  return <AppLayout><DashboardPage /></AppLayout>;
}
